import { SOURCE_IMG_TYPE } from '../uploadImageAndCrop/interface';

/**
 * ImgCropPortal 组件属性接口
 */
export interface IProps {
    src: string;
    cropRatio: number;
    teacherId: string;
    panelTitle?: string;
    uploadLoadText: string;
    multiple?: number; // 裁切倍数
    sourceImgType: SOURCE_IMG_TYPE;
    isShowToolBar?: boolean; // 是否显示工具栏
    onErr(): void;
    onCancel(): void;
    onChangeImg(): void;
    onConfirm(data: string): void;
}

/**
 * 图片变换状态接口
 */
export interface ImageTransform {
    rotation: number; // 旋转角度
    scaleX: number; // X轴缩放
    scaleY: number; // Y轴缩放
    translateX: number; // X轴平移
    translateY: number; // Y轴平移
}

/**
 * 裁剪参数接口
 */
export interface CropParams {
    scaleX: number;
    scaleY: number;
    completedCropWidth: number;
    completedCropHeight: number;
    offsetX: number;
    offsetY: number;
}

/**
 * 变换矩阵接口
 */
export interface TransformMatrix {
    a: number;
    b: number;
    c: number;
    d: number;
}

/**
 * 工具栏操作类型枚举
 */
export enum OPERATE_TYPE {
    ROTATE,
    ZOOM_IN,
    ZOOM_OUT,
}

// ==================== 原子化组件接口定义 ====================

/**
 * 裁剪面板标题组件属性
 */
export interface CropHeaderProps {
    title?: string;
}

/**
 * 会话图片组件属性
 */
export interface SessionImageProps {
    isSession: boolean;
    imgUrl: string;
}

/**
 * 裁剪工具栏组件属性
 */
export interface CropToolbarProps {
    onRotate: () => void;
    onZoomIn: () => void;
    onZoomOut: () => void;
}

/**
 * 裁剪区域组件属性
 */
export interface CropAreaProps {
    imgUrl: string;
    crop: any;
    sourceImgType: SOURCE_IMG_TYPE;
    onImageLoaded: (img: any) => void;
    onImageError: () => void;
    onChange: (crop: any, percentCrop: any) => void;
    onComplete: (crop: any, percentCrop: any) => void;
    children?: React.ReactNode;
}

/**
 * 裁剪操作按钮组件属性
 */
export interface CropButtonsProps {
    onChangeImg: () => void;
    onCancel: () => void;
    onConfirm: () => void;
}
